import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { sorting } from '@shared/constants/sorting';
import { StorageService } from '@shared/services/storage.service';

@Component({
  selector: 'app-device-sort',
  templateUrl: './device-sort.component.html',
  styleUrls: ['./device-sort.component.scss']
})
export class DeviceSortComponent implements OnInit {

  @Output() sortingElement = new EventEmitter<number>();
  selectedItem: number = 0;
  sortingTypes = sorting;

  constructor(private storage: StorageService) { }

  ngOnInit() {
    const storageItem = this.getStorage();

    if (storageItem !== null) {
      this.selectedItem = storageItem;
    } else {
      this.setStorage();
    }
  }

  sortBy(): void {
    this.setStorage();
    this.sortingElement.emit(this.selectedItem);
  }

  getStorage(): number {
    return JSON.parse(this.storage.getStorage(this.storage.sortingDevices));
  }

  setStorage(): void {
    this.storage.setStorage(JSON.stringify(this.selectedItem), this.storage.sortingDevices);
  }
}
